import SidebarLayout from "@/components/Shared/SidebarLayout";
export default {
  name: "wallet",
  components: { SidebarLayout },
  data() {
    return {
      items: [
        {
          text: this.$t("sidebars.wallet.portfolio"),
          link: null,
          disable: true,
          icon: "$sidebarPortfolio"
        },
        {
          text: this.$t("sidebars.wallet.main"),
          link: "/wallet/main",
          icon: "$sidebarMainWallet"
        },
        {
          text: this.$t("sidebars.wallet.spot"),
          link: "/wallet/spot",
          icon: "$sidebarSpotWallet"
        }
      ]
    };
  }
};
